import translator from "@/translator";
import { Form, Input, Button, Space, Switch, Select } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import React from "react";

const { TextArea } = Input;

const t = translator("note_office.views.services.service_form.");

const ServiceForm = ({
  form,
  initialValues,
  onFinish,
  loading,
  onCancel,
  duration_options,
  currency_options,
  format_options,
}) => {
  const handleFinish = (values) => {
    if (values.format === "online") {
      values.address = null;
    } else if (values.format === "offline") {
      values.meeting_url = null;
    }

    onFinish(values);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleFinish}
      initialValues={initialValues}
      className="wrapper_form wrapper_form__with-button overflow"
    >
      <div>
        <Form.Item name="name" className="contacts-form__item">
          <Input placeholder={t("placeholders.name")} className="contacts-form__input" />
        </Form.Item>

        <Form.Item name="duration" className="contacts-form__item">
          <Select
            placeholder={t("placeholders.duration")}
            options={duration_options.map((val) => ({
              value: val * 60,
              label: t("minutes", { count: val }),
            }))}
            className="profile-form__select"
          />
        </Form.Item>

        <div className="contacts-form__item">
          <div className="contacts-form__input services-form__input-border">
            <div className="services-form__input-checkbox">
              <span>{t("show_for_all")}</span>
              <Form.Item name="active" valuePropName="checked" noStyle>
                <Switch />
              </Form.Item>
            </div>
          </div>
          <div className="services-form__input-hint">
            <InfoCircleOutlined style={{ marginRight: 4, fontSize: 14, color: "#888" }} />
            {t("show_for_all_hint")}
          </div>
        </div>

        <div className="contacts-form__item">
          <Form.Item name="price_max" style={{ marginBottom: 0 }}>
            <Input
              type="number"
              step="0.01"
              placeholder={t("placeholders.price_max")}
              className="contacts-form__input"
            />
          </Form.Item>
          <Form.Item name="price_min">
            <Input
              type="number"
              step="0.01"
              placeholder={t("placeholders.price_min")}
              className="contacts-form__input"
            />
          </Form.Item>
        </div>

        <Form.Item name="currency">
          <Select
            options={currency_options}
            placeholder={t("placeholders.currency")}
            className="profile-form__select"
          />
        </Form.Item>

        <Form.Item name="format">
          <Select
            options={format_options}
            placeholder={t("placeholders.format")}
            className="profile-form__select"
          />
        </Form.Item>

        <Form.Item shouldUpdate={(prev, curr) => prev.format !== curr.format}>
          {({ getFieldValue }) => {
            const format = getFieldValue("format");
            return (
              <>
                {format === "online" && (
                  <Form.Item name="meeting_url" className="contacts-form__item">
                    <Input
                      placeholder={t("placeholders.meeting_url")}
                      className="contacts-form__input"
                    />
                  </Form.Item>
                )}
                {format === "offline" && (
                  <Form.Item name="address" className="contacts-form__item">
                    <Input
                      placeholder={t("placeholders.address")}
                      className="contacts-form__input"
                    />
                  </Form.Item>
                )}
              </>
            );
          }}
        </Form.Item>

        <Form.Item name="description" className="contacts-form__item">
          <TextArea
            placeholder={t("placeholders.description")}
            className="contacts-form__input resizable-textarea"
          />
        </Form.Item>
      </div>

      <Form.Item style={{ marginBottom: "20px" }}>
        <Space direction="vertical" size={16} className="button-group">
          <Button type="primary" htmlType="submit" block loading={loading} className="button-base">
            {t("buttons.save")}
          </Button>
          <Button type="default" block onClick={onCancel} className="button-base button-third">
            {t("buttons.cancel")}
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default ServiceForm;
